import { render, staticRenderFns } from "./MenuNav.vue?vue&type=template&id=0a0c2877&scoped=true&"
import script from "./MenuNav.vue?vue&type=script&lang=js&"
export * from "./MenuNav.vue?vue&type=script&lang=js&"
import style0 from "./MenuNav.vue?vue&type=style&index=0&id=0a0c2877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0c2877",
  null
  
)

export default component.exports